import React from 'react';
import * as S from '../styles';

export function TitleTabs({ title, dataScreen }) {
  return <S.Title statusLabel={dataScreen.codigoStatusMotorista}>{title}</S.Title>;
}
